<template>
  <div v-if="showInfo" class="seat-info" :style="{ top: position.top, left: position.left }">
    <div class="seat-container">
      <!-- <p>
        Pozicija <span>{{ this.result.position }}</span>
      </p> -->
      <p>
        {{ adminText('workflowsAll.red_cc9db3a', 'Red') }}<span> {{ workflowLabel(this.result.row) }}</span>
      </p>
      <p>
        {{ adminText('workflowsAll.sjedalo_2023ccc', 'Sjedalo') }} <span>{{ workflowLabel(this.result.seat) }}</span>
      </p>
    </div>
    <div class="price">
      <div>{{ workflowLabel(getPriceForSeat(this.ticket, this.seat)) }}</div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { exchangeRate } from '../../utils'

export default {
  mixins: [WorkflowDisplay],
  props: {
    orderItems: {
      type: Array,
      default: () => {
        return []
      },
    },
    seat: String,
    showInfo: Boolean,
    position: Object,
    ticket: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      exchangeRate: exchangeRate,
      result: this.extractString(this.seat),
    }
  },
  watch: {
    seat(newSeat) {
      if (newSeat) {
        this.result = this.extractString(newSeat)
      } else {
        this.result = null
      }
    },
  },
  methods: {
    extractString(inputString) {
      const regex = /Section-(\d+)_Row-(\d+)_Seat-(\d+)/
      let match = ''
      if (inputString) {
        match = inputString.match(regex)
      }

      if (match !== null) {
        const section = match[1]
        const row = match[2]
        const seat = match[3]

        return { section, row, seat }
      } else {
        return { section: '', row: '', seat: '' }
      }
    },
    getPriceForSeat(ticket, seat) {
      const matchedTicket = this.orderItems.find(
        ticketIn => ticketIn.id === ticket && ticketIn.sectionSeats.includes(seat),
      )

      return matchedTicket ? matchedTicket.price + ' EUR' : 'Price not available'
    },
  },
}
</script>

<style scoped>
.seat-info {
  border-radius: 0rem 0.75rem 0.75rem 0.75rem;
  border: 1px solid var(--grey-30, #ccc);
  z-index: 1000;
  position: absolute;
  background-color: white;
  border-collapse: separate;
}
.seat-title {
  padding: 2rem;
  padding-bottom: 0;
  padding-top: 1rem;
  color: var(--primary-10, #0277bd);
}
.seat-container {
  padding: 2rem;
  padding-top: 0.5rem;

  padding-bottom: 0;
  color: var(--grey-10, #666);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.045rem;
  display: flex;
  flex-direction: column;
}

.seat-container p {
  padding: 0;
  margin: 0;
}
span {
  color: var(--grey-10, #666);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.045rem;
}

.price {
  padding: 1rem 2rem;
  margin-top: 1rem;
  background: var(--grey-40, #f5f5f5);
  border-radius: 0 0 0rem 0.75rem;
  border: 0 0 0 1px solid var(--grey-30, #ccc);
  color: var(--grey-10, #666);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}
</style>
